import { View } from "../../Core";
import { ModalHelper } from "../../Helpers/ModalHelper";
import Vue from "vue";
import { Uri } from "../../Core/Helpers/Uri";
import * as ajax from "@brightspark/sparkling-ajax-js";
import XelectComponent from "../../Components/Xelect/XelectComponent.vue";
import ValidationMessage from "../../Components/ValidationMessage/ValidationMessage.vue";

enum Action {
    AddItemToCart,
    Checkout
}

class ViewDataModel {

    public itemId: string = "";
    public sizes: any[];
    public images: string[];
}

export class ItemView extends View<ItemView> {
    private _viewData: ViewDataModel = window.__VIEW_DATA;

    public constructor() {
        super();
        this.SetupVue();
    }

    SetupVue() {
        var modalHelper;
        const v = new Vue({
            el: ".app",
            data: {
                sizes: this._viewData.sizes,
                model: {
                    itemId: this._viewData.itemId,
                    amount: 1,
                    size: this._viewData.sizes[0] ? this._viewData.sizes[0].value : "",
                },
                validationResults: {},
                images: this._viewData.images,
                currentImageUrl: this._viewData.images[0]
            },
            beforeMount() {
                modalHelper = new ModalHelper(this);
            },
            mounted() {
                
            },
            components: {
                XelectComponent,
                ValidationMessage
            },
            methods: {
                increaseAmount() {
                    this.model.amount++;
                },
                decreaseAmount() {

                    if (this.model.amount <= 1) {
                        this.model.amount = 1;
                    }
                    else {
                        this.model.amount--;
                    }
                },
                addItemToCart() {

                    ajax(Uri.getUri(Action[Action.AddItemToCart]), { contentType: "application/json", dataType: "json", method: "post", data: this.model })
                        .done((res: any) => {
                            if (!res.isSuccess) {
                                v.validationResults = res.validationResults;
                                return;
                            }

                            modalHelper.getModal({
                                title: "Toode on lisatud ostukorvi",
                                //text: text,
                                buttons: [
                                    {
                                        title: "Vormistan tellimuse",
                                        handler: () => {
                                            document.location.href = Uri.getUri(Action[Action.Checkout]);
                                        }
                                    },
                                    {
                                        title: "Jätkan ostlemist",
                                        default: true,
                                        handler: () => {
                                            modalHelper.hide();
                                        }
                                    }
                                ]
                            });
                        });

                }
            }
        });
    }
}


// WEBPACK FOOTER //
// ./www/js/Pages/Shop/ItemView.ts